import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runTableQuery } from '@/pages/shared/rtk-query-helpers';

export const staffApi = createApi({
    reducerPath: 'staffApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getTableData: builder.mutation({
            query: (data) => ({ url: '/api/staff/list', method: 'POST', body: data }),
        }),
    }),
});

export const runStaffTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, staffApi.endpoints.getTableData, requestData);

export default staffApi;
